import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { OFFER_MADE, ON_SALE, ITEM_SOLD } from './favNotificationsConstants';
import { getItemEventLinkClickedTrackingObjs } from './trackingHelpers.es';
import style from './FavNotificationsTile-style.scss';

const makeUrl = ({ item, eventType }) => {
    if (eventType === OFFER_MADE) {
        return `${item.pdpURL}?modal=offer`;
    } else if (eventType === ON_SALE || eventType === ITEM_SOLD) {
        return item.pdpURL;
    }
    return '';
};

const trackClick = ({ item, eventType }) => {
    const trackingObjs = getItemEventLinkClickedTrackingObjs({item, eventType});
    trackingObjs.forEach(trackingObj => trackEvent(trackingObj));
};

const messages = {
    [ON_SALE]: {
        text: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileDescription.sale_text'
                defaultMessage="This item's price has decreased."
            />
        ),
        link: {
            text: (
                <FormattedMessage
                    id='dbl.Header.FavNotificationsTileDescription.sale_link_text'
                    defaultMessage='View Item'
                />
            )
        }
    },
    [OFFER_MADE]: {
        text: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileDescription.offer_text'
                defaultMessage='An offer has been made on this item.'
            />
        ),
        link: {
            text: (
                <FormattedMessage
                    id='dbl.Header.FavNotificationsTileDescription.offer_link_text'
                    defaultMessage='Make Offer'
                />
            )
        }
    },
    [ITEM_SOLD]: {
        text: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileDescription.sold_text'
                defaultMessage='This item was sold.'
            />
        ),
        link: {
            text: (
                <FormattedMessage
                    id='dbl.Header.FavNotificationsTileDescription.sold_link_text'
                    defaultMessage='View similar items'
                />)
        }
    }
};

const FavNotificationsTileDescription = ({ tile }) => {
    const { items, eventType } = tile;
    const item = items[0];
    const { text, link } = messages[eventType] || {};
    const url = makeUrl({item, eventType});

    return (
        <div className={style.itemDescr}>
            {text && text}
            {link && link.text && url &&
                <div className={style.itemDescrLink}>
                    <a href={url} onClick={() => {trackClick({item, eventType });}}>{link.text}</a>
                </div>
            }
        </div>
    );
};

FavNotificationsTileDescription.propTypes = {
    tile: PropTypes.object.isRequired
};

export default createFragmentContainer(FavNotificationsTileDescription, {
    tile: graphql`
        fragment FavNotificationsTileDescription_tile on FavoriteNotification {
            items {
                serviceId
                pdpURL
            }
            eventType
        }
    `
});



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTileDescription.jsx